(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["balqees-ships-by"] && !Shopify.designMode) return;
  try {
    (() => {
    const cacheKey = 'balqees-bank-holidays-england-wales-v1';
    const refreshAfter = 60 * 60 * 1000;
    const maximumCacheAge = 7 * 24 * 60 * 60 * 1000;

    let holidayData = null;
    let loading = false;
    let lastAttempt = 0;

    const londonFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hourCycle: 'h23'
    });

    const displayFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'UTC',
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });

    function validData(data) {
      return data &&
        Number.isFinite(data.savedAt) &&
        Array.isArray(data.dates) &&
        data.dates.length > 0 &&
        data.dates.every(date =>
          typeof date === 'string' &&
          /^\d{4}-\d{2}-\d{2}$/.test(date)
        );
    }

    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey));
      if (validData(cached)) holidayData = cached;
    } catch (error) {}

    function updateDispatchDate() {
      const roots = document.querySelectorAll('[data-ships-by]');
      if (!roots.length) return;

      if (
        !validData(holidayData) ||
        Date.now() - holidayData.savedAt > maximumCacheAge
      ) {
        roots.forEach(root => { root.hidden = true; });
        return;
      }

      const values = Object.fromEntries(
        londonFormatter.formatToParts(new Date()).map(
          ({ type, value }) => [type, value]
        )
      );

      const today =
        values.year + '-' + values.month + '-' + values.day;

      const dispatchDate = new Date(Date.UTC(
        Number(values.year),
        Number(values.month) - 1,
        Number(values.day)
      ));

      if (Number(values.hour) >= 11) {
        dispatchDate.setUTCDate(dispatchDate.getUTCDate() + 1);
      }

      const holidays = new Set(holidayData.dates);
      const iso = date => date.toISOString().slice(0, 10);

      while (
        dispatchDate.getUTCDay() === 0 ||
        dispatchDate.getUTCDay() === 6 ||
        holidays.has(iso(dispatchDate))
      ) {
        dispatchDate.setUTCDate(dispatchDate.getUTCDate() + 1);
      }

      const coveredYears = new Set(
        holidayData.dates.map(date => Number(date.slice(0, 4)))
      );

      if (!coveredYears.has(dispatchDate.getUTCFullYear())) {
        roots.forEach(root => { root.hidden = true; });
        return;
      }

      const parts = Object.fromEntries(
        displayFormatter.formatToParts(dispatchDate).map(
          ({ type, value }) => [type, value]
        )
      );

      const formattedDate =
        parts.weekday + ' ' + parts.day + ' ' + parts.month;

      const message =
        (iso(dispatchDate) === today ? 'today, ' : '') +
        formattedDate;

      roots.forEach(root => {
        const dateElement = root.querySelector('[data-ships-by-date]');
        if (!dateElement) return;

        if (dateElement.textContent !== message) {
          dateElement.textContent = message;
        }

        root.hidden = false;
      });
    }

    async function refreshHolidays() {
      if (loading) return;

      const now = Date.now();

      if (
        validData(holidayData) &&
        now - holidayData.savedAt < refreshAfter
      ) {
        return;
      }

      if (now - lastAttempt < 60000) return;

      loading = true;
      lastAttempt = now;

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);

      try {
        const response = await fetch(
          'https://www.gov.uk/bank-holidays.json',
          {
            signal: controller.signal,
            credentials: 'omit'
          }
        );

        if (!response.ok) throw new Error('Holiday data unavailable');

        const data = await response.json();
        const events = data['england-and-wales']?.events;

        if (!Array.isArray(events) || !events.length) {
          throw new Error('Invalid holiday data');
        }

        const updated = {
          savedAt: Date.now(),
          dates: events.map(event => event.date)
        };

        if (!validData(updated)) {
          throw new Error('Invalid holiday dates');
        }

        holidayData = updated;

        try {
          localStorage.setItem(cacheKey, JSON.stringify(updated));
        } catch (error) {}
      } catch (error) {
      } finally {
        clearTimeout(timeout);
        loading = false;
        updateDispatchDate();
      }
    }

    function initialise() {
      updateDispatchDate();
      refreshHolidays();
    }

    initialise();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, {
        once: true
      });
    }

    document.addEventListener('shopify:section:load', initialise);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) initialise();
    });

    setInterval(() => {
      if (!document.hidden) updateDispatchDate();
    }, 1000);

    setInterval(() => {
      if (!document.hidden) refreshHolidays();
    }, 60000);
  })();
  } catch(e) { console.error(e); }
})();

})();
